import { openDatabaseDesktop } from './openDatabaseDesktop.js';
import { openDatabaseMobile } from './openDatabaseMobile';

export const openSQLiteDatabase = databaseOptions => {
  if (window && window.cordova) {
    if (window.cordova.platformId !== 'browser') {
      return openDatabaseMobile(databaseOptions);
    } else {
      return openDatabaseDesktop(databaseOptions);
    }
  } else {
    throw new Error('Cordova not installed');
  }
};
